import { RootAction, RootState } from '@src/app/_redux';
import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { clearSessionState } from '@src/app/_global/utility/persistedStorage';
import { config as AWSConfig } from 'aws-sdk/global';
import { USER_LOGOUT } from '@src/app/header/actions';
import { actionCreators as gaActionCreators } from '@src/app/analytics/googleAnalytics/actions';
import { actionCreators } from '@src/app/header/actions';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

export const clearAWSCreds = (
    action$: ActionsObservable<RootAction>,  
    state$: StateObservable<RootState>) =>
  action$.pipe(
    ofType(USER_LOGOUT),
    mergeMap(() => {
      if (AWSConfig.credentials) {
        AWSConfig.credentials.accessKeyId = '';
        AWSConfig.credentials.secretAccessKey = '';
        AWSConfig.credentials.sessionToken = '';
      }
      // remove next line after adding complete persistence
      clearSessionState();
      gaActionCreators.createGAEvent({ category: 'Logout', action: 'Successful', label: state$.value.clientConfig.clientConfig.magCode, });
      actionCreators.userLogoutSuccessNotification();
      return of(actionCreators.userLogoutSuccess());
    }),
  );



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/header/epics.ts